import React from "react";

// function renderJudges(attendees) {
//   if (!attendees || attendees.length === 0) return null;

//   // Collect unique judges
//   const singleJudges = new Set();
//   const multiJudges= {}; // e.g., { judge_A: 'Name', judge_B: 'Name' }

//   attendees.forEach(attendee => {
//     if (attendee.judge) singleJudges.add(attendee.judge);

//     if (attendee.judge_A) multiJudges['A'] = attendee.judge_A;
//     if (attendee.judge_B) multiJudges['B'] = attendee.judge_B;
//     if (attendee.judge_C) multiJudges['C'] = attendee.judge_C;
//   });

//   // Render
//   if (singleJudges.size > 0) {
//     return <span>Judge: {[...singleJudges].join(" | ")}</span>;
//   }

//   const judgeEntries = Object.entries(multiJudges);
//   if (judgeEntries.length > 0) {
//     return (
//       <span>
//         {judgeEntries.map(([key, name], i) => (
//           <React.Fragment key={key}>
//             Judge {key}: {name}{i < judgeEntries.length - 1 ? " | " : ""}
//           </React.Fragment>
//         ))}
//       </span>
//     );
//   }

//   return null;
// }

function renderJudges(attendees) {
  if (!attendees || attendees.length === 0) return null;

  // Collect unique judge names across all attendees
  const judgesSet = new Set();

  attendees.forEach(attendee => {
    // Single judge field
    if (attendee.judge) judgesSet.add(attendee.judge);

    // Multiple judge fields (judge_A, judge_B, judge_C, etc.)
    Object.keys(attendee).forEach(key => {
      if (key.startsWith("judge_") && attendee[key]) {
        judgesSet.add(attendee[key]);
      }
    });
  });

  const judges = Array.from(judgesSet);
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

  // Formatting logic
  if (judges.length <= 3) {
    return (
      <span>
        {judges.map((name, index) => (
          <React.Fragment key={index}>
            Judge {alphabet[index]}: {name}
            {index < judges.length - 1 ? " | " : ""}
          </React.Fragment>
        ))}
      </span>
    );
  }

  // More than 3 judges → condensed format
  return <span>Judges: {judges.join(", ")}</span>;
}

export const CategoryConfig = {
  "Agility Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),

  },

  "Beagle Field Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),

  },

  "Chase Ability Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),

  },

  "Draft Dog Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),

  },

  "Earthdog Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Herding Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Lure Coursing Field Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Pointing Field Dog Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Pointing Field Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },


  "Pointing Water Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Retriever Field Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },
  "Retriever Hunt Test": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Working Certificate Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Scent Detection": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Spaniel Field Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Spaniel Hunt Test": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Sprinter": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Tracking Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

  "Canine Good Neighbour": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number}  | {renderJudges(attendees)}</p>
      </>
    ),
  },

};
